import { render } from "./MuseumIllustration.vue?vue&type=template&id=347af99b&scoped=true"
import script from "./MuseumIllustration.vue?vue&type=script&lang=js"
export * from "./MuseumIllustration.vue?vue&type=script&lang=js"

import "./MuseumIllustration.vue?vue&type=style&index=0&id=347af99b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347af99b"]])

export default __exports__